import { getAuthenticatedRoutes, unauthenticatedRoutes } from '@/routes.tsx';
import * as Sentry from '@sentry/react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { useAuth } from '@/hooks/use-auth.ts';
import { useCustomers } from '@/hooks/use-customers.ts';
import { useTheme } from '@/hooks/use-theme.ts';

import { LoadingPage } from '@/pages/loading-page.tsx';

import { useAuthStore } from '@/stores/auth-store.ts';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

export const Router = () => {
    const { authUser } = useAuth();
    const isUserSet = useAuthStore((state) => state.isUserSet);
    useCustomers();
    useTheme();

    const getBrowserRouter = (): ReturnType<typeof sentryCreateBrowserRouter> | undefined => {
        const browserRouter = sentryCreateBrowserRouter(authUser ? getAuthenticatedRoutes() : unauthenticatedRoutes);
        return browserRouter;
    };

    const router = getBrowserRouter();

    if (!isUserSet || !router) {
        return <LoadingPage />;
    }

    return <RouterProvider router={router} />;
};
